<form [formGroup]="form" class="bg-white rounded shadow-lg overflow-hidden" (ngSubmit)="onSave()">
  <div class="bg-red-700 text-white px-6 py-3 text-lg font-semibold">Export Details:</div>
  <div class="content px-6 py-4 flex flex-col gap-2">
    <div *ngIf="getErrorMessage()" class="text-xs text-red-600">{{ getErrorMessage() }}</div>

    <ng-container *ngIf="exportDetailsLoading$ | async; else loadedDetails">
      <div class="flex justify-center items-center py-8">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #loadedDetails>
      <div *ngIf="exportDetails$ | async as exportDetails">
        <div class="flex flex-row gap-8 mt-2">
          <div class="flex-1" *ngIf="hasShopTraveller(exportDetails)">
            <div class="font-semibold mb-2">Shop Traveller Pages:</div>
            <div class="border rounded p-4 flex flex-col gap-2">
              <ng-container *ngFor="let page of exportDetails.shopTraveller; let i = index">
                <mat-checkbox [formControl]="getShopTravellerControl(i)">
                  {{ page.name }}
                </mat-checkbox>
              </ng-container>
            </div>
          </div>
          <div class="flex-1" *ngIf="hasAttachments(exportDetails)">
            <div class="font-semibold mb-2">Attachments:</div>
            <div class="border rounded p-4 flex flex-col gap-2">
              <ng-container *ngFor="let att of exportDetails.attachments; let j = index">
                <mat-checkbox [formControl]="getAttachmentsControl(j)">
                  {{ att.name }}
                </mat-checkbox>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="flex flex-row gap-8 mt-2">
          <div class="flex-1" *ngIf="hasJobAttachments(exportDetails)">
            <div class="font-semibold mb-2">Job Attachments:</div>
            <div class="border rounded p-4 flex flex-col gap-2">
              <ng-container *ngFor="let jobAtt of exportDetails.jobAttachments; let k = index">
                <mat-checkbox [formControl]="getJobAttachmentsControl(k)">
                  {{ jobAtt.name }}
                </mat-checkbox>
              </ng-container>
            </div>
          </div>
          <div class="flex-1" *ngIf="hasShipmentAttachments(exportDetails)">
            <div class="font-semibold mb-2">Shipment Attachments:</div>
            <div class="border rounded p-4 flex flex-col gap-2">
              <ng-container
                *ngFor="let shipAtt of exportDetails.shipmentAttachments; let l = index"
              >
                <mat-checkbox [formControl]="getShipmentAttachmentsControl(l)">
                  {{ shipAtt.name }}
                </mat-checkbox>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="flex justify-end items-center gap-4 px-6 py-4">
    <button mat-flat-button type="button" (click)="onCancel()" class="text-blue-600">CANCEL</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid || exportOrderLoading()"
      class="!bg-green-600 !hover:bg-green-700 !text-white font-semibold shadow-md"
    >
      <ng-container *ngIf="!exportOrderLoading(); else loading">Export pages</ng-container>
      <ng-template #loading>
        <div class="flex items-center gap-2">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Exporting...</span>
        </div>
      </ng-template>
    </button>
  </div>
</form>
